import React, { useEffect } from 'react';
import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import Teaxtarea from '../../../../components/elements/form/textarea';
import SelectBox from '../../../../components/elements/form/selectBox';
import { DropdownOptionType, Option } from '../../../../_config/types';
import Datepicker from '../../../../components/elements/form/datepicker';
import Button from '../../../../components/elements/button';
import Icon from '../../../../components/icons';
import { usePurchaseRequestApi } from '../../../../store/api/hooks/purchaseApiHook';
import { useFacilitiesApi } from '../../../../store/api/hooks/facilitiesApiHook';
import CreatePurchaseRequestParts from './createPurchasedRequestParts';
import CreatePurchasedRequestAssets from './createPurchasedRequestAssets';
import toast from 'react-hot-toast';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import { useCommonApi } from '../../../../store/api/hooks/commonApiHook';
import moment from 'moment';
import Loader from '../../../../components/loader';
import { useUserSelector } from '../../../../store/selectors/userSelector';
import { useSpearPartsApi } from '../../../../store/api/hooks/spearPartsApiHook';

interface CreatePurchaseRequestFormProps {
    PrID?: any;
    WO?: any;
    onCreate?: () => void;
    onCancel?: () => void;
}

type FormValues = {
    purchaseRequestCode: string
    purchaseRequestTypeID: DropdownOptionType;
    purchaseRequestDetails: [],
    facilityID: DropdownOptionType;
    subFacilityID: DropdownOptionType;
    requiredByDate: Date;
    iswoenable: boolean;
    purchaseRequestWorkOrder: Option[];
    notes: string;
    reason: string;
    requesterID: DropdownOptionType;
    purchaseRequestStatusID: string;
};

const CreatePurchaseRequest: React.FC<CreatePurchaseRequestFormProps> = ({ PrID = null, WO = null, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, register, handleSubmit, formState: { errors }, watch, getValues, setValue } = useForm<FormValues>();
    const purchaseApi = usePurchaseRequestApi();
    const sparePartsAPI = useSpearPartsApi();
    const facilityApi: any = useFacilitiesApi();
    const workOrderApi: any = useWorkOrderApi();
    const commonApi: any = useCommonApi();

    const assetLineItemReRenderRef = React.useRef<boolean>(false);

    const [prTypeList, setPrTypeList] = React.useState<Option[]>([]);
    const [lineItemMode, setLineItemMode] = React.useState<string>(``);
    const [facilityList, setFacilityList] = React.useState<Option[]>([]);
    const [showWOsecion, setShowWOsecion] = React.useState<boolean>(false);
    const [showLoader, setShowLoader] = React.useState<boolean>(false);
    //const [subfacilityList, setSubFacilityList] = React.useState<Option[]>([]);
    const [lineItems, setLineItems] = React.useState<Array<any>>([]);

    const loggedinuser: any = useUserSelector();

    const purchaseRequestTypeID = watch(`purchaseRequestTypeID`);
    const facilityID = watch(`facilityID`);
    const purchaseRequestCode = watch(`purchaseRequestCode`);
    const purchaseRequestWorkOrder: any[] = watch(`purchaseRequestWorkOrder`);


    const getSubFacilityList = async (facilityID: any) => {
        /*
        const subfacilityresp = await new Promise((resolve, reject) => {
            facilityApi.getSubFacilityList({ facilityID: facilityID }, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('subFacilityList') && Array.isArray(resp.subFacilityList)) {
                    resp.subFacilityList = resp.subFacilityList.map((item: any) => {
                        return {
                            label: item.subFacilityName,
                            value: item.subFacilityID
                        };
                    });
                    resolve(resp.subFacilityList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([]);
            });
        }).catch(err => {
            return [];
        });
        setSubFacilityList(subfacilityresp as Array<Option>);
        */
    };

    const handleWOSearch = async (inputValue: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            workOrderApi.GetWorkOrderList({ pageSize: 50, pageNumber: 1, searchParam: (inputValue ? inputValue.trim() : inputValue) }, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('workOrderList') && Array.isArray(resp.workOrderList)) {
                    const options = resp.workOrderList.map((item: any) => ({
                        label: item.workOrderCode,
                        value: item.workOrderID
                    }));
                    resolve(options);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                console.error("Error fetching Tasks", error);
                reject([]);
            });
        });
    };

    const handleUserSearch = async (inputValue: string): Promise<any[]> => {
        return new Promise((resolve, reject) => {
            commonApi.GetUserList({
                pageSize: 50,
                pageNumber: 1,
                searchParam: (inputValue ? inputValue.trim() : inputValue)
            }, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('userList') && Array.isArray(resp.userList)) {
                    resp.userList = resp.userList.map((user: any) => {
                        return {
                            label: user.firstName + " " + user.lastName,
                            value: user.userID,
                        }
                    });
                    resolve(resp.userList);
                } else {
                    resolve([]);
                }
            }, (error: any) => {
                reject([]);
            });
        });
    };

    const _isDuplicateLineItems_parts = (dataset: Array<any>) => {
        const seen = new Set();
        const duplicates = [];
        for (const item of dataset) {
            const key = item.partsID + `-` + item.vendorID;
            if (seen.has(key)) {
                duplicates.push(item);
            } else {
                seen.add(key);
            }
        }
        return duplicates;
    };

    const _isDuplicateLineItems_assets = (dataset: Array<any>) => {
        const seen = new Set();
        const duplicates = [];
        for (const item of dataset) {
            const key = item.assetName + `-` + item.vendorID;
            if (seen.has(key)) {
                duplicates.push(item);
            } else {
                seen.add(key);
            }
        }
        return duplicates;
    };

    const onSavePR = () => {
        const data: any = getValues();
        data[`purchaseRequestStatusID`] = 1; // Set status to Draft
        onSubmit(data);
        // Implement save logic here
    };

    const onSubmit = async (data: any) => {
        console.log(data);
        const payload: any = Object.assign({}, JSON.parse(JSON.stringify(data)));
        payload.purchaseRequestID = PrID || null;
        delete payload.iswoenable;
        console.log("Lineitems is -> ", lineItems);
        if (lineItemMode === `parts`) {
            if (lineItems.length > 0) {
                if (_isDuplicateLineItems_parts(lineItems).length > 0) {
                    toast.error(`Same parts with same vendor cannot be added multiple times. Please remove duplicates. and try again.`);
                    return;
                }
                console.log(lineItems);
                const incompletedparts = lineItems.filter((item: any) => {
                    //return !item.partsID || !item.vendorID || !+item.requiredQty || !item.unitID;
                    return !item.partsID || !+item.requiredQty || !item.unitID;
                });
                if (incompletedparts.length > 0) {
                    //toast.error(`Please complete all the required fields for parts before submitting. E.g. Parts, Vendor, Required Qty.`);
                    toast.error(`Please complete all the required fields for parts before submitting. E.g. Parts, Required Qty.`);
                    return;
                }
                payload.purchaseRequestDetails = lineItems.map((item: any) => {
                    return {
                        partsID: item.partsID,
                        vendorID: item.vendorID,
                        requiredQty: +item.requiredQty,
                        unitID: item.unitID,
                        totalAmount: (+item.unitPrice * +item.requiredQty),
                    };
                });
                payload.potentialAsset = [];
            } else {
                toast.error(`Please add at least one part to the purchase request.`);
                return;
            }
        }
        if (lineItemMode === `assets`) {
            if (lineItems.length > 0) {
                if (_isDuplicateLineItems_assets(lineItems).length > 0) {
                    toast.error(`Same assets with same vendor cannot be added multiple times. Please remove duplicates. and try again.`);
                    return;
                }
                console.log(lineItems);
                const incompletedassets = lineItems.filter((item: any) => {
                    //return !item.assetName || !item.vendorID || !+item.requiredQty;
                    return !item.assetName || !+item.requiredQty;
                });
                if (incompletedassets.length > 0) {
                    //toast.error(`Please complete all the required fields for assets before submitting. E.g. Assets, Vendor, Required Qty.`);
                    toast.error(`Please complete all the required fields for assets before submitting. E.g. Assets, Required Qty.`);
                    return;
                }
                payload.potentialAsset = lineItems.map((item: any) => {
                    return {
                        //assetID: item.assetID || null,
                        assetName: item.assetName,
                        vendorID: item.vendorID,
                        unitID: 5,
                        requiredQty: +item.requiredQty,
                        totalAmount: +item.totalAmount
                    };
                });


                //###########################
                //payload.potentialAsset = []; // Temporarily disabling asset addition tomorrow morning just remove this line to enable asset addition
                //###########################

                payload.purchaseRequestDetails = [];
            } else {
                toast.error(`Please add at least one asset to the purchase request.`);
                return;
            }
        }

        payload.purchaseRequestTypeID = payload.purchaseRequestTypeID.value;
        payload.facilityID = payload.facilityID.value;
        payload.subFacilityID = null;
        payload.requesterID = payload.requesterID && typeof (payload.requesterID) === 'object' ? payload.requesterID.value : null;
        payload.requiredByDate = payload.requiredByDate ? moment(payload.requiredByDate).utc().toISOString() : null;
        if (payload.purchaseRequestWorkOrder && Array.isArray(payload.purchaseRequestWorkOrder)) {
            payload.purchaseRequestWorkOrder = payload.purchaseRequestWorkOrder.map((item: any) => {
                return {
                    workOrderID: item.value,
                };
            });
        } else {
            payload.purchaseRequestWorkOrder = [];
        }
        if (!payload.hasOwnProperty(`purchaseRequestStatusID`) || (payload.hasOwnProperty(`purchaseRequestStatusID`) && !payload.purchaseRequestStatusID)) {
            payload.purchaseRequestStatusID = 2;
        }
        console.log("Payload: ", payload);
        setShowLoader(true);
        const prcreateresp: any = await new Promise((resolve, reject) => {
            purchaseApi.SavePurchaseRequest(payload, (resp: any) => {
                //console.log("xxxs");
                resolve(resp);
            }, (error: any) => {
                console.log("error", error);
                toast.error(error);
                reject(error);
            });
        }).catch((error: any) => {
            setShowLoader(false);
            return null;
        });
        setShowLoader(false);
        if (prcreateresp && prcreateresp.code === 200 && prcreateresp.hasOwnProperty('successful') && prcreateresp.successful === true) {
            toast.success(prcreateresp.message || `Purchase Request created successfully!`);
            onCreate();
        } else {
            toast.error(prcreateresp?.message || `Failed to create Purchase Request!`);
        }
        console.log("Purchase Request Created: ", prcreateresp);
    };




    const init_page_data = async () => {
        setShowLoader(true);
        // Purchase Request Type List
        const purchasetyperesp = await new Promise((resolve, reject) => {
            purchaseApi.GetPurchaseRequestTypeList({}, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('purchaseRequestTypeList') && Array.isArray(resp.purchaseRequestTypeList)) {
                    resp.purchaseRequestTypeList = resp.purchaseRequestTypeList.map((item: any) => {
                        return {
                            label: item.prTypeName,
                            value: item.prTypeID
                        };
                    })
                    resolve(resp.purchaseRequestTypeList);
                } else {
                    reject([]);
                }
            }, (error: any) => {
                console.log("Purchase request type list error", error);
                reject([]);
            });
        }).catch((error: any) => {
            return [];
        });
        setPrTypeList(purchasetyperesp as Array<Option>);

        // Facility List
        const facilityresp = await new Promise((resolve, reject) => {
            facilityApi.getFacilityList({}, (resp: any) => {
                if (resp && resp.code === 200 && resp.hasOwnProperty('successful') && resp.successful === true && resp.hasOwnProperty('facilityList') && Array.isArray(resp.facilityList)) {
                    resp.facilityList = resp.facilityList.map((item: any) => {
                        return {
                            label: item.facilityName,
                            value: item.facilityID
                        };
                    })
                    resolve(resp.facilityList);
                } else {
                    reject([]);
                }
            }, (error: any) => {
                console.log("Facility list error", error);
                reject([]);
            });
        }).catch((error: any) => {
            return [];
        });
        setFacilityList(facilityresp as Array<Option>);
        setShowLoader(false);
        console.log("loggedinuser", loggedinuser);
        console.log("PrID: ", PrID);
        if (loggedinuser)
            setValue(`requesterID`, { value: loggedinuser.userID, label: loggedinuser.firstName + ` ` + loggedinuser.lastName });

        if (!PrID) {
            setShowLoader(true);
            // Generate PR code
            const prcoderesp = await new Promise((resolve, reject) => {
                purchaseApi.GetPurchaseRequestCode({}, (resp: any) => {
                    console.log("Purchase Request Code Response: ", resp.code);
                    if (resp && resp.code) {
                        resolve(resp.code);
                    } else {
                        reject(null);
                    }
                }, (error: any) => {
                    toast.error(`Failed to generate Purchase Request Code!`);
                    reject(null);
                });
            }).catch((error: any) => {
                setShowLoader(false);
                return null;
            });
            setShowLoader(false);
            console.log("prcoderesp", prcoderesp)
            setValue(`purchaseRequestCode`, prcoderesp as string);
        } else {
            setShowLoader(true);
            const prdetails: any = await new Promise((resolve, reject) => {
                purchaseApi.GetPurchaseRequestById({ PurchaseRequestID: PrID }, (resp: any) => {
                    if (resp && resp.hasOwnProperty('purchaseRequestID') && +resp.purchaseRequestID > 0) {
                        resolve(resp);
                    } else {
                        toast.error(`Failed to fetch Purchase Request details!`);
                        reject(null);
                    }
                }, (error: any) => {
                    toast.error(error);
                    reject(null);
                });
            }).catch((error: any) => {
                setShowLoader(false);
                return null;
            });
            setShowLoader(false);

            setValue(`requesterID`, { value: prdetails.requesterID, label: prdetails.requesterName });
            if (prdetails) {
                /*                
                purchaseRequestDetails: [],
                facilityID: DropdownOptionType;
                subFacilityID: DropdownOptionType;
                requiredByDate: Date;
                purchaseRequestWorkOrder: Option[];
                notes: string;
                reason: string;
                requesterID: DropdownOptionType;
                purchaseRequestStatusID: string;
                */
                setValue(`purchaseRequestCode`, prdetails.purchaseRequestCode as string);
                setValue(`purchaseRequestTypeID`, { value: prdetails.purchaseRequestTypeID, label: prdetails.purchaseRequestTypeName });
                if (+prdetails.purchaseRequestTypeID === 1 && prdetails.purchaseRequestItemList) {
                    setLineItemMode(`parts`);
                    const bind_pritemlist = prdetails.purchaseRequestItemList.map((o: any) => {
                        return {
                            partsID: o.partsID,
                            vendorPartCode: o.partsCode,
                            vendorPartName: o.partName,
                            vendorID: o.vendorID,
                            vendorName: o.vendorName,
                            requiredQty: +o.requiredQty,
                            unitID: o.unitID,
                            unitPrice: +o.pricePerUnit || 0,
                            unitName: o.unitCode,
                            totalAmount: o.totalAmount, //((+o.pricePerUnit * +o.requiredQty) || 0) || o.totalAmount,
                            isEdit: false
                        }
                    });
                    setLineItems(bind_pritemlist);
                }
                if ((+prdetails.purchaseRequestTypeID === 2 || +prdetails.purchaseRequestTypeID === 3) && prdetails.purchaseAsset) {
                    setLineItemMode(`assets`);
                    const bind_pritemlist = prdetails.purchaseAsset.map((o: any) => {
                        return {
                            assetID: o?.assetID,
                            assetName: o.assetName,
                            vendorID: o.vendorID,
                            vendorName: o.vendorName,
                            unitID: o.unitID,
                            unitCode: `Each`,
                            unitPrice: +o.unitPrice || 0,
                            requiredQty: +o.requiredQty,
                            totalAmount: +o.totalAmount,
                            isEdit: false
                        }
                    });
                    setLineItems(bind_pritemlist);
                    assetLineItemReRenderRef.current = true;
                }
                setValue(`requiredByDate`, moment.utc(prdetails.requiredByDate).local().toDate());
                setValue(`facilityID`, { value: prdetails.facilityID, label: prdetails.facilityName });
                //setValue(`subFacilityID`, prdetails.subFacilityID ? {value: prdetails.subFacilityID, label: prdetails.subFacilityName} : null);
                setValue(`notes`, prdetails.notes || ``);
                setValue(`reason`, prdetails.reason || ``);
                if (prdetails.purchaseWO && Array.isArray(prdetails.purchaseWO) && prdetails.purchaseWO.length > 0) {
                    const bindwo = prdetails.purchaseWO.map((item: any) => {
                        return {
                            label: item.workOrderCode,
                            value: item.workOrderID
                        };
                    });
                    setValue(`purchaseRequestWorkOrder`, bindwo);
                    setShowWOsecion(true);
                    setValue(`iswoenable`, true);
                }
                setValue(`requesterID`, { value: prdetails.requesterID, label: prdetails.requesterName });

            }
            console.log("Purchase Request Details: ", prdetails);
        }

        if (WO) {
            setShowLoader(true);
            const wodata: any = await new Promise((resolve, reject) => {
                workOrderApi.GetWorkOrderByID({ WorkOrderID: WO }, (resp: any) => {
                    resolve(resp);
                }, (error: any) => {
                    toast.error(error);
                    reject(error);
                })
            }).catch((error: any) => {
                return null;
            });
            if (wodata && wodata.hasOwnProperty("workOrderID")) {
                console.log("WO parts are ", wodata.workOrderPartsMappingList);
                const purchaseItemList: any[] = [];
                for await (const partx of wodata.workOrderPartsMappingList) {
                    const part: any = await new Promise((resolve, reject) => {
                        sparePartsAPI.getSpearPartsList({
                            pageSize: 10,
                            pageNumber: 1,
                            searchParam: partx.partsCode,
                        }, (resp: any) => {
                            if (resp && resp.code === 200 && resp.successful === true && resp.hasOwnProperty(`sparePartsList`) && Array.isArray(resp.sparePartsList) && resp.sparePartsList.length > 0) {
                                const bindParts = resp.sparePartsList.find((o: any) => +o.partsID === +partx.partsID);
                                resolve(bindParts || null);
                            } else {
                                resolve(null);
                            }
                        }, (error: any) => {
                            reject(null)
                        });
                    });
                    console.log("part is", part);
                    if (part) {
                        purchaseItemList.push({
                            partsID: part.partsID,
                            vendorPartCode: part.partsCode,
                            vendorPartName: part.sparePartsName,
                            vendorID: null,
                            vendorName: null,
                            requiredQty: +partx?.requiredQty,
                            unitID: part.unitID,
                            unitPrice: +part.pricePerUnit || 0,
                            unitName: part.unitCode,
                            totalAmount: ((+part.pricePerUnit * +partx.requiredQty) || 0),
                            isEdit: false
                        });
                    } else {
                        purchaseItemList.push({
                            partsID: partx.partsID,
                            vendorPartCode: partx.partsCode,
                            vendorPartName: partx.sparePartsName,
                            vendorID: null,
                            vendorName: ``,
                            requiredQty: +partx?.requiredQty,
                            unitID: partx?.unitID,
                            unitPrice: (+partx?.pricePerUnit || 0),
                            unitName: ``,
                            totalAmount: ((+partx?.pricePerUnit || 0) * +partx?.requiredQty),
                            isEdit: false
                        });
                    }
                }
                setValue(`purchaseRequestTypeID`, { value: 1, label: `Inventory Purchase` });
                setLineItemMode(`parts`);
                setLineItems(purchaseItemList);
                setShowLoader(false);
                setValue(`purchaseRequestWorkOrder`, [{
                    label: wodata.workOrderCode,
                    value: wodata.workOrderID
                }]);
                setShowWOsecion(true);
                setValue(`iswoenable`, true);
                console.log("purchaseItemList", purchaseItemList);
            }
        }




    };

    useEffect(() => {
        var prtypeID: any = typeof purchaseRequestTypeID === `undefined` ? null : purchaseRequestTypeID;
        if (prtypeID && prtypeID.hasOwnProperty('value')) {
            if (+prtypeID.value == 1) {
                setLineItemMode(`parts`);
                setLineItems([]); // Reset line items for parts
            }

            if (+prtypeID.value == 2 || +prtypeID.value == 3) {
                setLineItemMode(`assets`);
                if (!assetLineItemReRenderRef.current) {
                    console.log("Exec here");
                    setLineItems([]); // Reset line items for assets
                }
            }
        } else {
            setLineItemMode(``);
        }
    }, [purchaseRequestTypeID]);


    /*
    useEffect(() => {
        console.log("Facility ID changed: ", facilityID);
        if (typeof (facilityID) !== `undefined` && facilityID && facilityID.hasOwnProperty('value')) {
            const factypebrek: any = facilityID;
            getSubFacilityList(factypebrek.value);
        }
    }, [facilityID]);
    */

    useEffect(() => {
        init_page_data();
    }, []);

    return (
        <div className={`relative`}>
            {showLoader && (
                <div className={`absolute p-8 w-full h-full z-[2px] bg-white bg-opacity-30`}>
                    <Loader />
                </div>
            )}
            <form onSubmit={handleSubmit(onSubmit)} className={`${showLoader ? `hidden` : `block`}`} noValidate>
                <div className={`pt-4`}>
                    <div className='bg-green-50 py-2 px-3'>
                        <h6 className='text-[0.813rem] font-semibold'>Purchase Request ID</h6>
                        <p className='text-[0.813rem] font-normal mt-2'>{purchaseRequestCode || `...`}</p>
                    </div>
                    <Controller
                        name='purchaseRequestTypeID'
                        control={control}
                        rules={{ required: `Please purchase type!` }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Purchase Type'
                                value={value}
                                onChange={(e:any) => {
                                    assetLineItemReRenderRef.current = false;
                                    onChange(e);
                                }}
                                required
                                placeholder='Inventory Purchase'
                                options={prTypeList}
                                className='mb-0'
                                error={errors.purchaseRequestTypeID?.message}
                            />
                        )}
                    />
                    
                    {(() => {
                        if (lineItemMode === `parts`) {
                            return (
                                <CreatePurchaseRequestParts data={lineItems} onUpdate={setLineItems} />
                            )
                        }
                        if (lineItemMode === `assets`) {
                            return (
                                <CreatePurchasedRequestAssets data={lineItems} onUpdate={setLineItems} />
                            )
                        }
                    })()}

                    <Controller
                        name='requiredByDate'
                        control={control}
                        rules={{ required: `Please select required by date!` }}
                        render={({ field: { value, onChange } }) => (
                            <Datepicker
                                label='Required by'
                                value={value}
                                onChange={onChange}
                                required
                                minDate={new Date()}
                                error={errors.requiredByDate?.message}
                            />
                        )}
                    />
                    <Controller
                        name='facilityID'
                        control={control}
                        rules={{ required: `Please select facility!` }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Ship To'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Select Location'
                                options={facilityList}
                                className='mb-0'
                                error={errors.facilityID?.message}
                            />
                        )}
                    />

                    <p className={`mt-5`}>
                        <label className={`font-normal`}>
                            <input type={`checkbox`} {...register(`iswoenable`)} className={`mr-2`} onClick={(e: any) => {
                                if (e.target.checked) {
                                    setShowWOsecion(true);
                                } else {
                                    setShowWOsecion(false);
                                }
                            }} />
                            Associate a Task
                        </label>
                    </p>
                    <div className={`${!showWOsecion ? `hidden` : ``}`}>
                        <Controller
                            name='purchaseRequestWorkOrder'
                            control={control}
                            render={({ field: { value, onChange } }) => (
                                <SelectBox
                                    label='Task'
                                    value={value ? value : []}
                                    onChange={onChange}
                                    placeholder={`Search and select a Task`}
                                    isMulti={true}
                                    isClearable={true}
                                    options={[]}
                                    className='mb-0'
                                    async={true}
                                    asyncLoadOptions={async (inputValue: string) => {
                                        return handleWOSearch(inputValue);
                                    }}
                                />
                            )}
                        />
                    </div>

                    <Controller
                        name='notes'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <Teaxtarea
                                label='Note to Approver and Preferred Vendors'
                                value={value}
                                onChange={onChange}
                                placeholder='Enter notes here.'
                            />
                        )}
                    />
                    <Controller
                        name='reason'
                        control={control}
                        render={({ field: { value, onChange } }) => (
                            <Teaxtarea
                                label='Describe Reason for Re-order'
                                value={value}
                                onChange={onChange}
                                placeholder='Describe Reason for Re-order'
                            />
                        )}
                    />
                    <Controller
                        name='requesterID'
                        control={control}
                        rules={{ required: `Please select requester!` }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Name of Requester'
                                value={value}
                                onChange={onChange}
                                required
                                placeholder='Search of Requester'
                                options={[]}
                                className='mb-0'
                                async={true}
                                isClearable={true}
                                asyncLoadOptions={async (inputValue: string) => {
                                    return handleUserSearch(inputValue);
                                }}
                                error={errors.requesterID?.message}
                            />
                        )}
                    />
                </div>
                <div className={`sticky bottom-0 bg-white z-[1px]`}>
                    <hr className={`border-gray-900 my-6 sticky z-[1px] bottom-6`} />
                    <div className={`flex justify-end gap-2`}>
                        <Button type={`submit`}>Send for Approval</Button>
                        <Button type={`button`} childstyle={{ paddingLeft: `20px`, paddingRight: `20px` }} onClick={() => onSavePR()}>Save</Button>
                        <Button theme='secondary' childstyle={{ paddingLeft: `20px`, paddingRight: `20px` }} onClick={() => onCancel()}>Cancel</Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default CreatePurchaseRequest;